import { render, staticRenderFns } from "./OdpCourseDatesCoursesMenu.vue?vue&type=template&id=6508e005&scoped=true"
import script from "./OdpCourseDatesCoursesMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./OdpCourseDatesCoursesMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OdpCourseDatesCoursesMenu.vue?vue&type=style&index=0&id=6508e005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508e005",
  null
  
)

export default component.exports